import { render, staticRenderFns } from "./RegisterCardTemplate.vue?vue&type=template&id=fcd2fb4c&scoped=true&"
import script from "./RegisterCardTemplate.vue?vue&type=script&lang=js&"
export * from "./RegisterCardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCardTemplate.vue?vue&type=style&index=0&id=fcd2fb4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd2fb4c",
  null
  
)

export default component.exports